import React from "react";

import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaList } from "../../../components/ContentBuilder/MarginaliaList/MarginaliaList";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadTopicPdf } from "./downloadFile";

// Topic PDF in public/files/pdf; the download button is hidden while this is undefined.
const TOPIC_PDF_FILENAME: string | undefined = "applia-home-appliance-monitor-2025-production.pdf";

export const productionPageMarginalia: MarginaliaData = {
	component: MarginaliaGroup,
	props: {
		children: [
			<MarginaliaTitle key="on-this-page-title" title="On this page" />,
			<MarginaliaList
				key="on-this-page-list"
				items={[
					{
						label: "Material use during the production process",
						scrollTo: "production-material-use-during-production",
					},
					{
						label: "Quantities of individual materials used in home appliances",
						scrollTo: "production-quantities-of-individual-materials",
					},
					{
						label: "Average material composition of large home appliances",
						scrollTo: "production-avg-material-composition-large",
					},
					{
						label: "Average material composition of small home appliances",
						scrollTo: "production-avg-material-composition-small",
					},
				]}
			/>,
			<div key="topic-download-spacer" className="mt-3">
				<MarginaliaTitle title="Topic download" />
			</div>,
			...(TOPIC_PDF_FILENAME ? [<MarginaliaButton key="download" variant="download" icon="document" label="Production" sublabel="PDF" onClick={() => downloadTopicPdf(TOPIC_PDF_FILENAME)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this topic" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(window.location.href)} />,
		],
	},
};
